// Use environment variable for API base URL
// In production, set REACT_APP_API_URL in your environment
const BASE_URL = "https://api.namohomesindia.com";
// const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";
export default BASE_URL;
